module.exports = __webpack_public_path__ + "static/media/14.Vaccum Blower.220bc42b.jpg";